import { createFileRoute, useNavigate } from "@tanstack/react-router"
import BudgetYearCollectionsView from "~/components/budget/BudgetYearCollectionsView"

export const Route = createFileRoute("/_auth/budgets/_layout/$fiscalYear/_layout/collections")({
  component: RouteComponent,
})

function RouteComponent() {
  const { fiscalYear } = Route.useParams()
  const navigate = useNavigate()

  return (
    <BudgetYearCollectionsView
      year={fiscalYear}
      onYearChange={(year) =>
        navigate({
          to: "/budgets/$fiscalYear/collections",
          params: { fiscalYear: year },
        })
      }
    />
  )
}
